import { logEntryIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { EntryPage } from "../logbook/entry-page.tsx";
import { loadLogEntry } from "../logbook/loaders.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { LogEntryPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/logbook/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null || viewer.role === "vendor" ? (
    <NoAccessPage />
  ) : (
    <EntryPage viewer={viewer} entryId={id} />
  );
};

export const Route = createFileRoute("/_app/logbook/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(logEntryIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadLogEntry(context.data, params.id),
  pendingComponent: LogEntryPending,
  component: Page,
});
